import { call, select } from 'redux-saga/effects';

import request from '../request';
import selectors from '../../../selectors';
import api from '../../../api';
import Paths from '../../../constants/Paths';

export function* fetchBoardByCurrentPath() {
  const pathsMatch = yield select(selectors.selectPathsMatch);

  let board;
  let card;
  let users;
  let projects;
  let boardMemberships;
  let labels;
  let lists;
  let cards;
  let cardMemberships;
  let cardLabels;
  let tasks;
  let attachments;
  // FAMILY-EXT: feature 1+2
  let cardWaitingActions;

  if (pathsMatch) {
    let boardId;
    if (pathsMatch.pattern.path === Paths.BOARDS) {
      boardId = pathsMatch.params.id;
    } else if (pathsMatch.pattern.path === Paths.CARDS) {
      const cardResponse = yield call(request, api.getCard, pathsMatch.params.id);
      card = cardResponse.item;
      boardId = cardResponse.item.boardId;
      // FAMILY-EXT
      cardWaitingActions =
        cardResponse.included && cardResponse.included.cardWaitingActions;
    }

    if (boardId) {
      const boardResponse = yield call(request, api.getBoard, boardId, true);
      board = boardResponse.item;
      ({
        users,
        projects,
        boardMemberships,
        labels,
        lists,
        cards,
        cardMemberships,
        cardLabels,
        tasks,
        attachments,
      } = boardResponse.included);
      // FAMILY-EXT: журнал ожиданий приходит в ответе getBoard для всех карточек
      // Если он есть, объединяем с тем, что было от getCard (по факту дублей нет —
      // та же карточка вернула те же записи)
      if (boardResponse.included.cardWaitingActions) {
        const fromBoard = boardResponse.included.cardWaitingActions;
        if (cardWaitingActions) {
          const ids = new Set(cardWaitingActions.map((a) => a.id));
          cardWaitingActions = cardWaitingActions.concat(
            fromBoard.filter((a) => !ids.has(a.id)),
          );
        } else {
          cardWaitingActions = fromBoard;
        }
      }
    }
  }

  return {
    board,
    card,
    users,
    boardMemberships,
    labels,
    lists,
    cards,
    cardMemberships,
    cardLabels,
    tasks,
    attachments,
    // FAMILY-EXT
    cardWaitingActions,
    project: projects[0],
  };
}

export default {
  fetchBoardByCurrentPath,
};
